import type { PipelineStepId } from '../model/template-generation.types';

/**
 * Keyed on the sub-agent ids the workflow runs, which the stream reports as `data-agent` nodes.
 *
 * The previous runtime synthesized tool events carrying translated labels, so a step matched on
 * copy and a locale change would have broken it. An agent id is stable, and it is the same string
 * the workflow declares.
 */
const AGENT_STEP_IDS = {
  'template-gen-extract-files': 'reading-files',
  'template-gen-sections': 'generating-sections',
} as const satisfies Record<string, Exclude<PipelineStepId, 'saving-template'>>;

export const matchPipelineStep = (agentId: string): PipelineStepId | null => {
  if (Object.hasOwn(AGENT_STEP_IDS, agentId)) {
    return AGENT_STEP_IDS[agentId as keyof typeof AGENT_STEP_IDS];
  }
  return null;
};
